module.exports = __webpack_public_path__ + "static/media/water.d575bf39.mp3";